import * as React from 'react';
import { Chips } from '@cian/ui-kit';

import { houseTypeDescriptor } from '../../constants/descriptors';
import { isDescriptorActive } from '../../utils/filters';
import { connectToDescriptors, IDescriptorProps } from '../сonnectToDescriptors';
import { getOffersCount } from '../../actions/offersData';
import { TTypedThunkDispatch } from '../../types/thunk';

export interface IHouseTypeProps extends IDescriptorProps<string> {
  getOffersCount(): void;
}

const HouseTypeComponent: React.FC<IHouseTypeProps> = React.memo(
  ({ actionCreator, getOffersCount, jsonQuery, descriptors }) => {
    const options = React.useMemo(
      () =>
        descriptors.map(({ state, label }) => ({
          label,
          value: state,
        })),
      [descriptors],
    );

    const activeDescriptors = descriptors.filter(descriptor => isDescriptorActive(descriptor)(jsonQuery));
    const currentValues = React.useMemo(() => activeDescriptors.map(d => d.state), [activeDescriptors]);

    const handleChipClick = React.useCallback(
      (value: string) => {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        actionCreator(descriptors.find(d => d.state === value)!)();
        getOffersCount();
      },
      [actionCreator, descriptors, getOffersCount],
    );

    return (
      <Chips options={options} size="S" value={currentValues} selectType="multiple" onChipClick={handleChipClick} />
    );
  },
);

HouseTypeComponent.displayName = 'HouseTypeComponent';

function mapDispatchToProps(dispatch: TTypedThunkDispatch) {
  return {
    getOffersCount: () => {
      dispatch(getOffersCount());
    },
  };
}

export const HouseType = connectToDescriptors(houseTypeDescriptor, mapDispatchToProps)(HouseTypeComponent);
